import Vue from 'vue'

import room from './room'
import call from './call'
import tailwind from './tailwind'

Vue.mixin(room)
Vue.mixin(call)
Vue.mixin(tailwind)
